module.exports = __webpack_public_path__ + "static/media/megara.1e3b389d.png";